import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { showNotification } from '@/services/calculate'

export default {
  props: ['type', 'name', 'value', 'bankIds'],
  data: function() {
    return {
      visible: false,
      process: false,
      data: null,
      duration: 0,
      datafromSocket: null,
      processContent: `Your request for downloading ${this.name} template will be processed shortly...`,
      progress: 0,
      intervalId: null,
      status: 'active',
      count: 0,
      fileName: '',
    }
  },
  created() {
    this.$socketHub.$on('message-received', this.messageReceived)
  },
  beforeDestroy() {
    this.$socketHub.$off('message-received')
  },
  mounted() {
    this.exportData()
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.duration = null
      if (this.type === 'TenantBank') {
        if (this.count === this.bankIds.length) {
          this.$emit('clickedCancel')
        }
      } else {
        this.$emit('clickedCancel')
      }
    },

    exportData() {
      this.fileName = undefined
      const that = this
      this.$notification.info({
        message: 'Export Request',
        description: (
          <div>
            <div>
              Your request for exporting {that.name} will be processed shortly.
            </div>
            <div>You will be notified once the request is completed</div>
          </div>
        ),
        duration: that.duration,
      })
      let url = masterAPIs.export(this.type.toLowerCase(), this.value)
      if (this.type !== 'PROJECT_TENANT' && this.type !== 'TEMPLATE_TENANT') {
        let typeOfdata = this.type.replace('_', '-')
        if (this.type === 'HISTORICAL_COST_INDEX') {
          typeOfdata = 'HISTORICAL-COST-INDEX'
        }
        url = masterAPIs.exportMaster(typeOfdata.toLowerCase())
      }
      if (this.type !== 'GroupingBank' && this.type !== 'TenantBank') {
        instance
          .get(url)
          .then(res => {
            if (res.status === 200) {
              this.data = _.get(res.data, 'result', [])
            }
          })
          .catch(err => {
            errorService(err)
          })
      } else if (this.type === 'GroupingBank') {
        this.exporBank(masterAPIs.groupingBank.export)
      } else if (this.type === 'TenantBank') {
        this.exporBank(masterAPIs.tenantBank.export)
      }
    },

    exporBank(url) {
      instance
        .post(url, this.bankIds)
        .then(res => {
          if (res.status === 200) {
            this.data = _.get(res.data, 'result', [])
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
      return buf
    },

    downloadData() {
      const that = this
      this.$notification.destroy()
      this.$notification.info({
        message: 'Downloading File',
        description: function(createElement) {
          return createElement('div', [
            createElement(
              'div',
              'Please wait while your file is downloading...',
            ),
            createElement('a-progress', {
              props: {
                percent: that.progress,
              },
              attrs: {
                status: that.status,
              },
            }),
          ])
        },
        duration: that.duration,
      })
      this.downloadProgress()
      instance
        .post(masterAPIs.download, that.datafromSocket, {
          responseType: 'arraybuffer',
        })
        .then(response => {
          if (response.status === 200) {
            var blob = new Blob([response.data])
            const fileURL = URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            if (this.fileName) {
              fileLink.setAttribute('download', this.fileName)
            } else {
              fileLink.setAttribute('download', that.type + '.xlsx')
            }
            document.body.appendChild(fileLink)
            that.handleCancel()
            fileLink.click()
            that.status = 'success'
            that.progress = 100
            setTimeout(function() {
              that.$notification.destroy()
            }, 1000)
          }
        })
        .catch(err => {
          that.status = 'exception'
          that.progress = 100
          setTimeout(function() {
            that.$notification.destroy()
          }, 1000)
          that.handleCancel()
          errorService(err)
        })
    },

    downloadProgress() {
      const that = this
      this.intervalId = setInterval(function() {
        if (that.progress < 50) {
          that.progress = that.progress + 1
        } else if (that.progress >= 50 && that.progress < 75) {
          that.progress = that.progress + 0.5
        } else if (that.progress >= 75 && that.progress < 90) {
          that.progress = that.progress + 0.25
        } else if (that.progress >= 90 && that.progress < 95) {
          that.progress = that.progress + 0.1
        } else if (that.progress >= 95) {
          that.progress = that.progress + 0.01
        } else {
          clearInterval(that.intervalId)
        }
      }, 200)
    },

    // socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === 'FileDownloaded') {
        data.name = this.name
        this.datafromSocket = data.Result
        this.$root.$emit('socketMessage', data)
        this.downloadData()
      } else if (data.EventType === 'FileExported') {
        if (data.Status === 'SUCCESS') {
          data.name = data.Result.DownloadName
          this.fileName = data.name
          this.datafromSocket = {
            Type: data.Result.fileType,
            FileName: data.Result.FilePath,
            ContentType: data.Result.ContentType,
            IsUploaded: true,
          }
          this.count++
          this.downloadData()
        } else if (data.Status === 'ERROR') {
          showNotification(
            'warning',
            'Import',
            _.get(data.Result, 'Message', ''),
          )
          this.$emit('clickedCancel')
        }
      }
    },
  },
}
